import { ToastConfig, ToastRef } from '@gh/core-ui';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export enum ToastStatus {
  Blocked,
  Free,
  Closed,
}

export class ToastItem {
  readonly afterClosed = new Subject<void>();
  private readonly statusSubject = new BehaviorSubject<ToastStatus>(ToastStatus.Free);

  constructor(public readonly config: ToastConfig) {
  }

  get status(): Observable<ToastStatus> {
    return this.statusSubject.asObservable();
  }

  get currentStatus(): ToastStatus {
    return this.statusSubject.value;
  }

  block(): void {
    if (!this.statusSubject.closed) {
      this.statusSubject.next(ToastStatus.Blocked);
    }
  }

  free(): void {
    if (!this.statusSubject.closed) {
      this.statusSubject.next(ToastStatus.Free);
    }
  }

  close(): void {
    if (this.afterClosed.closed) {
      return;
    }
    this.afterClosed.next();
    this.afterClosed.complete();
    this.statusSubject.complete();
  }
}

export class DefaultToastRef implements ToastRef {
  constructor(private readonly item: ToastItem) {
  }

  get afterClosed(): Observable<void> {
    return this.item.afterClosed.asObservable();
  }

  close(): void {
    this.item.close();
  }
}
